import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageKeys } from '../enums/storage-keys.enum';
import { UrlKeys } from '../enums/urls.enum';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

export const loggedGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const url: string = !inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA)
    ?.isAdmin
    ? `/${UrlKeys.LOGIN}`
    : `/${UrlKeys.MAINTENANCE}`;
  return inject(AuthService).isLogged() &&
    (!inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA)?.isAdmin ||
      (!!inject(StorageService).sessionStorageGetItem(StorageKeys.LOGIN_DATA)?.isAdmin &&
        !!inject(StorageService).sessionStorageGetItem(StorageKeys.USER_LOGIN_REQUESTER)))
    ? true
    : inject(Router).createUrlTree([url]);
};
export const notLoggedGuard: CanActivateFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return !inject(AuthService).isLogged()
    ? true
    : inject(Router).createUrlTree([`/${UrlKeys.HOME}`]);
};
